(ns dre.pages.my-searches.tags.events
  (:require
   [clojure.string :as str]
   [dre.components.flash.events :as-alias flash]
   [dre.i18n.views :refer [tr]]
   [dre.modals.events :as-alias modals]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.coll :refer [some-hash-map index-by]]
   [dre.network :as-alias network]
   [dre.utils.query :as q]
   [dre.utils :refer [aborted-request?]]
   [dre.shared.interface.search.util :refer [blunt-key]]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path :tags)

;; -- Events

(rf/reg-event-fx
 ::fetch
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ [_]]
  {:db {:state :loading}
   ::network/request [{:endpoint :saved/tags}
                      {:on-success [::success-fetch]
                       :on-failure [::failure-fetch]}]}))

(rf/reg-event-fx
 ::success-fetch
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  {:db (-> db
           (assoc-in [:data :tags] (:body response))
           (assoc :state :success))}))

(rf/reg-event-fx
 ::failure-fetch
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  (if (aborted-request? response)
    {}
    {:db (-> db
             (assoc :state :failure)
             (assoc :data nil))
     :dispatch-n [[:dre.network/default-failure opts]]})))

(rf/reg-event-fx
 ::tag-filter
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [filter]]
  {:db (-> db
           (assoc-in [:data :tag-filter] filter))}))

(rf/reg-event-fx
 ::delete
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [uuids]]
  (if (seq uuids)
    (let [current (first uuids)
          r (vec (rest uuids))]
      {:db (-> db
               (assoc :state :loading))
       ::network/request [{:endpoint :saved/delete-tags
                           :context {:id current}}
                          {:on-success [::success-delete {:uuids r}]
                           :on-failure [::failure-delete]}]})
    nil)))

(rf/reg-event-fx
 ::success-delete
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [:uuids ::fetch-fx/response]}]]
  (if (seq uuids)
    {:dispatch [::delete uuids]}
    {:db (-> db
             (assoc :state :success))
     :dispatch-n [[::fetch]]})))

(rf/reg-event-fx
 ::failure-delete
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (-> db
           (assoc :state :failure))
   :dispatch-n [[::fetch]
                [:dre.network/default-failure opts]]}))

(rf/reg-event-fx
 ::copy
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [tag_uuid new-name]]
  (let [tags (get-in db [:data :tags] nil)
        exist? (contains? (set (map :name tags))
                          new-name)]
    (if exist?
      {:dispatch [::flash/show
                [:span [:b [tr "There already seems to be tag with the same name."] [:br]]]
                :severity :error]}
      {:db {:state :loading}
       :fx [[:dispatch [::modals/clear]]
            [::network/request [{:endpoint :saved/action-tags}
                                {:body {:actions [{:action "create"
                                                   :name new-name
                                                   :copy-from tag_uuid}]}
                                 :on-success [::success-edit]
                                 :on-failure [::failure-edit]}]]]}))))

(rf/reg-event-fx
 ::edit
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [tag_uuid name description color source+uris after-fx]]
  (let [tags (get-in db [:data :tags] nil)
        prev_tag (:tag_uuid (first (filter #(= name (:name %)) tags)))
        new? (not tag_uuid)
        exist? (and prev_tag (not= tag_uuid prev_tag))
        action {:action "create"
                :name name
                :description (or description "")
                :color (or (when-not (str/blank? color)
                             color) "")}
        action (if source+uris
                 (assoc action :articles source+uris)
                 action)]
    (if exist?
      {:dispatch [::flash/show
                  [:span [:b [tr "There already seems to be tag with the same name."] [:br]]]
                  :severity :error]}
      (if new?
        {:db {:state :loading}
         :fx [[:dispatch [::modals/clear]]
              [::network/request [{:endpoint :saved/action-tags}
                                  {:body {:actions [action]} 
                                   :on-success [::success-edit {:after-fx after-fx}]
                                   :on-failure [::failure-edit]}]]]}
        {:db {:state :loading}
         :fx [[:dispatch [::modals/clear]]
              [::network/request [{:endpoint :saved/edit-tag
                                   :context {:id tag_uuid}}
                                  {:body {:name name
                                          :description (or description "")
                                          :color (or (when-not (str/blank? color)
                                                       color) "")}
                                   :on-success [::success-edit {:after-fx after-fx}]
                                   :on-failure [::failure-edit]}]]]})))))


(rf/reg-event-fx
 ::success-edit
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [after-fx ::fetch-fx/response]}]]
  {:dispatch-n (remove nil? [[::fetch]
                             after-fx])}))

(rf/reg-event-fx
 ::failure-edit
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (-> db
           (assoc :state :failure))
   :dispatch-n [[:dre.network/default-failure opts]]}))



(rf/reg-event-fx
 ::tag-articles
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [actions after-fx]]
  (let []
    {:db {:state :loading}
     ::network/request [{:endpoint :saved/action-tags}
                        {:body {:actions actions}
                         :on-success [::success-edit {:after-fx after-fx}]
                         :on-failure [::failure-edit]}]})))

;; -- Subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (db-path db)))

(rf/reg-sub
 ::tag-filter
 :<- [::state]
 (fn [state _]
   (let [data (get-in state [:data :tag-filter] nil)]
     data)))

(rf/reg-sub
 ::tags-without-filter
 :<- [::state]
 (fn [state _]
   (let [data (get-in state [:data :tags] nil)]
     data)))

(rf/reg-sub
 ::tags-map-without-filter
 :<- [::state]
 (fn [state _]
   (let [data (get-in state [:data :tags] nil)]
     (into {} (map (fn [v] [(:tag_uuid v)  v]) data)))))

(rf/reg-sub
 ::tags
 :<- [::state]
 :<- [::tag-filter]
 (fn [[state tag-filter] _]
   (let [data (get-in state [:data :tags] nil)
         data (if (or (not tag-filter) (str/blank? tag-filter))
                data
                (filter (fn [{:keys [:name :description]}]
                          (let [label-match? (or (str/includes? (str/lower-case (or name "")) (-> (or tag-filter "")
                                                                                          (str/trim)
                                                                                          (str/lower-case)))
                                                 (str/includes? (str/lower-case (or description "")) (-> (or tag-filter "")
                                                                                          (str/trim)
                                                                                          (str/lower-case))))]
                            label-match?))
                        
                        data))]
     data)))

(rf/reg-sub
 ::loading?
 :<- [::state]
 (fn [state _]
   (let [data (get state :state nil)]
     (= :loading data))))